export default function faq() {
    $(document).ready(function(){
        $('section.answer div.list ul li').click(function(){
            $(this).children('p').slideToggle();
            $(this).toggleClass('rotate');
        });
    });

}
